import React from "react";
import { FaMoon, FaSun } from "react-icons/fa";
import Button from "../Button";
import { useTheme } from "../../../style/ThemeContext";

/**
 * ThemeToggle — кнопка переключения светлой/тёмной темы.
 * Требует ThemeProvider выше по дереву (есть fallback, но провайдер рекомендуется).
 *
 * @param {("primary"|"secondary"|"ghost"|"custom"|...)} [variant="ghost"]
 * @param {("sm"|"md"|"lg")} [size="md"]
 * @param {boolean} [withLabel=false]  Показать текст рядом с иконкой.
 * Остальные пропсы пробрасываются в Button.
 */
export default function ThemeToggle({
  variant = "ghost",
  size = "md",
  withLabel = false,
  ...rest
}) {
  const { isDark, toggleTheme } = useTheme();
  const label = isDark ? "Светлая тема" : "Тёмная тема";

  return (
    <Button
      variant={variant}
      size={size}
      onClick={toggleTheme}
      icon={isDark ? <FaSun /> : <FaMoon />}
      title={label}
      aria-label={label}
      aria-pressed={isDark}
      {...rest}
    >
      {withLabel ? label : null}
    </Button>
  );
}
